const mediaItems = [
  {
    title: '某小花片场耍大牌录音流出，导演当场发飙',
    duration: '03:25',
    views: '128万',
    gradient: 'from-primary-400/20 to-primary-600/30',
  },
  {
    title: '知名歌手被拍到与已婚制片人亲密同行',
    duration: '05:12',
    views: '96万',
    gradient: 'from-accent-400/20 to-accent-600/30',
  },
  {
    title: '独家：某流量艺人私下言论被曝光引众怒',
    duration: '02:48',
    views: '203万',
    gradient: 'from-secondary-400/20 to-secondary-500/30',
  },
];

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1160px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-accent-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            视频爆料
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 一手现场直击</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`relative aspect-video bg-gradient-to-br ${item.gradient} flex items-center justify-center`}>
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-play-fill text-2xl md:text-3xl text-primary-600"></i>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-foreground-900/70 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次观看
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}